const delivery = [
  {
    path: '/delivery-settings',
    name: 'delivery.settings',
    component: () => import('@/views/delivery/ProductDeliverySettings'),
    meta: {
      env:['production'],
      pageTitle: 'Configurações',
      roles: [1, 2, 5],
      breadcrumb: [
        {
          text: 'Restrições de Entrega Local',
          active: true,
        },
      ],
    },
  },

  {
    path: '/entregas/taxas-de-fretes',
    name: 'delivery.shipping-rates-fees',
    component: () => import('@/views/delivery/ShippingRatesFees'),
    meta: {
      env: ['production'],
      pageTitle: 'Taxas de fretes',
      roles: [1, 2, 5, 6, 8],
      breadcrumb: [
        {
          text: 'Taxas de fretes',
          active: true,
        },
      ],
    },
  },


]

export default delivery
